import { render, staticRenderFns } from "./MediaObject.vue?vue&type=template&id=fc27d020&scoped=true"
import script from "./MediaObject.vue?vue&type=script&lang=js"
export * from "./MediaObject.vue?vue&type=script&lang=js"
import style0 from "./MediaObject.vue?vue&type=style&index=0&id=fc27d020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc27d020",
  null
  
)

export default component.exports